<template>
  <v-chip
    :color="color"
    :size="small ? 'small' : 'default'"
    label
    class="font-weight-medium"
  >
    {{ label }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { AiReportStatus } from "@/api/ApiAiReport";

export default defineComponent({
  name: "AiReportStatusChip",
  props: {
    status: {
      type: String as PropType<AiReportStatus>,
      required: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    label(): string {
      if (this.status === "published") {
        return this.$t("aiReport.published") as string;
      }
      if (this.status === "draft") {
        return this.$t("aiReport.draft") as string;
      }
      return this.$t("aiReport.notGenerated") as string;
    },
    color(): string {
      if (this.status === "published") return "primary";
      if (this.status === "draft") return "amber";
      return "grey-lighten-1";
    },
  },
});
</script>
